// extracted by mini-css-extract-plugin
export default {"zoomModal":"T5-z"};